import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper'
import TypeConverter from '@/Utility/TypeConverter';
import KendoDateAndTimePickerViewModel from '@/Components/KendoDateTimePicker/ViewModels/KendoDateAndTimePickerViewModel';
import KendoDateAndTimePicker from '@/Components/KendoDateTimePicker/Controls/KendoDateAndTimePicker';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';

export default class KendoDateAndTimePickerFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private KendoDateAndTimePickerViewModel = ComponentManager.getViewModel<typeof KendoDateAndTimePickerViewModel>('KendoDateAndTimePickerViewModel');
    private KendoDateAndTimePicker = ComponentManager.getControl<typeof KendoDateAndTimePicker>('KendoDateAndTimePicker');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */ 
    public viewModel: KendoDateAndTimePickerViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: KendoDateAndTimePicker;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.KendoDateAndTimePickerViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            })
        });

        this.control = new this.KendoDateAndTimePicker(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);

        this.registerDefaultValidation([this.detailViewItem.name]);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.rawValue, (rawValue: string) => {
            let isNullableType = TypeConverter.typeIsNullable(this.detailViewItem.dotNetTypeName) || this.detailViewItem.useInFilter;

            if (isNullableType)
                return String.isNullOrEmpty(rawValue) || this.viewModel.date() != null;
            else
                return this.viewModel.date() != null;
        });

        return this.jQueryControl;
    }

    public getValueForFilter(): Object {
        let ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);

        return ret;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: DateHelper.toDotNetDateTimeString(this.viewModel?.date()) || ''
        }
    }
}

ComponentManager.setFactory('KendoDateAndTimePicker', KendoDateAndTimePickerFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');